import { render, staticRenderFns } from "./AriaLive.vue?vue&type=template&id=011724e4&scoped=true&"
import script from "./AriaLive.vue?vue&type=script&lang=ts&"
export * from "./AriaLive.vue?vue&type=script&lang=ts&"
import style0 from "./AriaLive.vue?vue&type=style&index=0&id=011724e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011724e4",
  null
  
)

export default component.exports